import React, { useState } from 'react'

import { Hero, VideoPlayButton } from '../../Common'
import { VideoModal } from './VideoModal'

export const VideoBlock = ({ pageBlock }) => {
    const [showModal, setShowModal] = useState(false)
    const [videoUrl, setVideoUrl] = useState('')

    const openModal = video_url => {
        setShowModal(true)
        setVideoUrl(video_url)
    }

    const closeModal = () => setShowModal(false)

    return (
        <>
            <Hero>
                <VideoPlayButton onClick={() => openModal(pageBlock.video_url)} />
            </Hero>
            <VideoModal
                url={pageBlock.video_url}
                showModal={showModal}
                closeModal={closeModal}
                full={true} />
        </>
    )
}
